const TxtProblemasObtener = 'Se presentaron problemas al obtener ';
const TxtProblemasEjecutar = 'Se presentaron problemas ';

export const MensajesGenericos_ES = [
    //buscadores
    {
        'codigo': 'SearchFilterDsc',
        'mensaje': 'La descripción es requerida.'
    },
    {
        'codigo': 'SearchFilterClasf',
        'mensaje': 'La clasificación es requerida.'
    },
    {
        'codigo': 'SearchAllFilterReq',
        'mensaje': 'Todos los filtros de búsqueda son requeridos.'
    },
    {
        'codigo': 'WarningSelectGradeCode',
        'mensaje': 'Debe seleccionar el grado académico para poder realizar la búsqueda.'
    },
    {
        'codigo': 'WarningSelectCareerCode',
        'mensaje': 'Debe seleccionar una carrera para poder realizar la búsqueda.'
    },
    {
        'codigo': 'ErrorProgramIdNotEmty',
        'mensaje': 'Debe seleccionar un programa académico para poder realizar la búsqueda.'
    },
    {
        'codigo': 'SearchFilterRequired',
        'mensaje': 'Debe ingresar al menos un filtro de búsqueda.'
    },
    //fin buscadores
    //base datos
    {
        'codigo': 'ErrorLinkPassExpired',
        'mensaje': 'El enlace de recuperación contraseña está vencido.'
    },
    {
        'codigo': 'UserInactive',
        'mensaje': 'El usuario se encuentra inactivo.'
    },
    {
        'codigo': 'ErrorDeleteConflictRecords',
        'mensaje': 'No se puede eliminar el registro porque esta siendo utilizado en otros procesos.'
    },
    //fin base datos
    //errores permisos
    {
        'codigo': 'UnauthorizedAccessModule',
        'mensaje': 'No tiene permisos para ingresar a este módulo.'
    },
    {
        'codigo': 'UnauthorizedAccessOption',
        'mensaje': 'No tiene permisos para ingresar a esta opción.'
    },
    {
        'codigo': 'UnauthorizedActionConsult',
        'mensaje': 'No tiene permisos para consultar registros en esta opción.'
    },
    {
        'codigo': 'UnauthorizedActionDelete',
        'mensaje': 'No tiene permisos para eliminar registros en esta opción.'
    },
    {
        'codigo': 'UnauthorizedActionInsert',
        'mensaje': 'No tiene permisos para ingresar registro en esta opción.'
    },
    {
        'codigo': 'UnauthorizedActionOption',
        'mensaje': 'No tiene permisos para realizar el proceso en esta opción.'
    },
    {
        'codigo': 'UnauthorizedActionUpdate',
        'mensaje': 'No tiene permisos para actualizar registros en esta opción.'
    },    
    //fin errores permisos
    //mensajes genericos
    {
        'codigo': 'error',
        'mensaje': 'Errores'
    },
    {
        'codigo': 'info',
        'mensaje': 'Información'
    },
    {
        'codigo': 'warning',
        'mensaje': 'Advertencia'
    },
    {
        'codigo': 'success',
        'mensaje': 'Éxitoso'
    },
    {
        'codigo': 'ok',
        'mensaje': 'Proceso realizado correctamente.'
    },
    {
        'codigo': 'insertOk',
        'mensaje': 'Registro creado correctamente.'
    },
    {
        'codigo': 'updateOk',
        'mensaje': 'Registro actualizado correctamente.'
    },
    {
        'codigo': 'deleteOk',
        'mensaje': 'Registro eliminado correctamente.'
    },
    {
        'codigo': 'InternalServerError',
        'mensaje': TxtProblemasEjecutar + 'al realizar la acción, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'Unauthorized',
        'mensaje': 'Credenciales incorrectos.'
    },
    {
        'codigo': 'WarningSelectRegistrationCode',
        'mensaje': 'Debe seleccionar un tipo de registro.'
    },
    {
        'codigo': 'ErrorUpdateFormatFile',
        'mensaje': TxtProblemasEjecutar + 'al actualizar los formatos de archivos.'
    },
    {
        'codigo': 'ErrorListFormatFile',
        'mensaje': TxtProblemasEjecutar + 'al listar los formatos de archivos.'
    },
    {
        'codigo': 'ErrorDateFormatFI',
        'mensaje': 'Debe ingresar una fecha inicio válida.'
    },
    {
        'codigo': 'ErrorDateFormatFF',
        'mensaje': 'Debe ingresar una fecha fin válida.'
    },
    {
        'codigo': 'CodeRequeridoAnno',
        'mensaje': 'El año es requerido.'
    },
    {
        'codigo': 'CodeRequeridoPeriodo',
        'mensaje': 'El período es requerido.'
    },
    {
        'codigo': 'CodeRequeridoDescripcion',
        'mensaje': 'La descripción es requerida.'
    },
    {
        'codigo': 'CodeRequeridoCode',
        'mensaje': 'El código es requerido.'
    },
    {
        'codigo': 'CodeRequeridoName',
        'mensaje': 'El nombre es requerido.'
    },
    {
        'codigo': 'CodeRequeridoStartTime',
        'mensaje': 'La hora inicial es requerida.'
    },
    {
        'codigo': 'CodeRequeridoEndTime',
        'mensaje': 'La hora final es requerida.'
    },
    {
        'codigo': 'CodeRequeridoInformacion',
        'mensaje': 'La información es requerida.'
    },
    {
        'codigo': 'CodeRequeridoCampus',
        'mensaje': 'La sede es requerida.'
    },
    {
        'codigo': 'ErrorListSedes',
        'mensaje': 'Se presentaron problemas al obtener el listado de sedes.'
    },
    {
        'codigo': 'ErrorRecordIdNotEmpty',
        'mensaje': 'Debe seleccionar un registro.'
    }, 
    {
        'codigo': 'ErrorValidEmailFormat',
        'mensaje': 'Debe ingresar un correo electrónico válido.'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'Se presentaron problemas al realizar el proceso de cambio de contraseña.'
    },
    {
        'codigo': 'ErrorEmailSend',
        'mensaje': 'Se presentaron problemas al realizar el envío de correos.'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Se ha realizado el cambio de contraseña.'
    },
    {
        'codigo': 'WarningNoExistenCamposDinamicos',
        'mensaje': 'No existen campos definidos para esta opción.'
    },
    //fin mensajes genericos
    //mensajes manejo archivos
    {
        'codigo': 'ErrorFile401',
        'mensaje': 'Se presentaron problemas al subir el archivo al servidor (permisos de escritura), comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorFile409',
        'mensaje': 'Ya existe un archivo en el servidor con ese mismo nombre.'
    },
    {
        'codigo': 'ErrorDataFileNotEmty',
        'mensaje': 'No se encontraron los datos del archivo.'
    },
    {
        'codigo': 'ErrorExtensionFileNotEmty',
        'mensaje': TxtProblemasEjecutar + 'con la extensión del archivo.'
    },
    {
        'codigo': 'ErrorFileNotFound',
        'mensaje': 'El archivo no ha sido encontrado.'
    },
    {
        'codigo': 'ErrorNameFileNotEmty',
        'mensaje': 'No se pudo obtener el nombre del archivo.'
    },
    {
        'codigo': 'ErrorNotFoundFile',
        'mensaje': 'No se encontró el archivo.'
    },
    {
        'codigo': 'ErrorMimeTypeNotEmty',
        'mensaje': TxtProblemasEjecutar + 'con la extensión del archivo.'
    },
    //fin mensajes manejo archivos
    //MENSAJES CORE
    {
        'codigo': 'CantAddPassword',
        'mensaje': 'Se presentaron problema al restablecer la contraseña, intentelo nuevamente.'
    },
    {
        'codigo': 'CantRemovePassword',
        'mensaje': 'Se presentaron problema al restablecer la contraseña, intentelo nuevamente.'
    },
    {
        'codigo': 'ErrorActionNotEmty',
        'mensaje': TxtProblemasEjecutar + 'al realizar la acción, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorActualizarUsuario',
        'mensaje': TxtProblemasEjecutar + 'al realizar la acción, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorAuditLog',
        'mensaje': 'Problemas al registrar auditoría.'
    },
    {
        'codigo': 'ErrorCapitalLetter',
        'mensaje': 'Debe ingresar al menos una letra mayúscula.'
    },
    {
        'codigo': 'ErrorCodLangNotEmty',
        'mensaje': TxtProblemasEjecutar + 'con el idioma, intentelo nuevamente.'
    },
    {
        'codigo': 'ErrorCompaniaIdNotEmty',
        'mensaje': 'No se encontraron los datos de la compañía.'
    },
    {
        'codigo': 'ErrorCompaniaNotEmty',
        'mensaje': 'No se encontraron los datos de la compañía.'
    },
    {
        'codigo': 'ErrorConfigEmailCompanyNotFound',
        'mensaje': 'No se encontró los datos de envio de correos, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorCustomerIdNotEmty',
        'mensaje': 'Debe seleccionar un CIF.'
    },
    {
        'codigo': 'ErrorDataAutorization',
        'mensaje': TxtProblemasObtener + 'los datos de autorización de acceso, por favor comuníquese con el administrador del sistema.'
    },    
    {
        'codigo': 'ErrorDescriptionItemNotEmty',
        'mensaje': 'Debe ingresar una descripción.'
    },
    {
        'codigo': 'ErrorEmailLongitud',
        'mensaje': 'El correo no debe tener más de 200 caracteres.'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'El correo no puede estar vacío.'
    },
    {
        'codigo': 'ErrorExistPasswordHistory',
        'mensaje': 'La nueva contraseña no debe ser igual con otra previamente registrada.'
    },    
    {
        'codigo': 'ErrorGetAddressType',
        'mensaje': TxtProblemasObtener + 'los tipos de direcciones.'
    },
    {
        'codigo': 'ErrorGetCategorySystemCode',
        'mensaje': TxtProblemasObtener + 'las categorías.'
    },
    {
        'codigo': 'ErrorGetCIFType',
        'mensaje': TxtProblemasObtener + 'los tipos de CIF.'
    },
    {
        'codigo': 'ErrorGetClient',
        'mensaje': TxtProblemasObtener + 'los datos de CIF.'
    },
    {
        'codigo': 'ErrorGetClientCivilStates',
        'mensaje': TxtProblemasObtener + 'los tipos de estados civil.'
    },
    {
        'codigo': 'ErrorGetClientGenders',
        'mensaje': TxtProblemasObtener + 'los tipos de géneros.'
    },
    {
        'codigo': 'ErrorGetClientIdentifiers',
        'mensaje': TxtProblemasObtener + 'los tipos de identificación.'
    },
    {
        'codigo': 'ErrorGetCompanyConfig',
        'mensaje': TxtProblemasObtener + 'la configuración de la compañía.'
    },
    {
        'codigo': 'ErrorGetCompanyInfo',
        'mensaje': TxtProblemasObtener + 'la información de la compañía.'
    },
    {
        'codigo': 'ErrorGetCompanyList',
        'mensaje': 'No se pudo obtener la lista de compañias.'
    },
    {
        'codigo': 'ErrorGetContactType',
        'mensaje': TxtProblemasObtener + 'los tipos de contactos.'
    },
    {
        'codigo': 'ErrorGetCountry',
        'mensaje': TxtProblemasObtener + 'la lista de países.'
    },
    {
        'codigo': 'ErrorGetCostumerImage',
        'mensaje': 'No se pudo obtener la imagen del CIF.'
    },
    {
        'codigo': 'ErrorGetDateFormat',
        'mensaje': 'No se pudo obtener los formatos de fechas.'
    },
    {
        'codigo': 'ErrorGetEmailCompanyConfig',
        'mensaje': TxtProblemasObtener + 'los datos de envio de correos de la compañía.'
    },
    {
        'codigo': 'ErrorGetProcessFlow', 
        'mensaje': 'No se pudo obtener el flujo de procesos.'
    },
    {
        'codigo': 'ErrorGetLocation1',
        'mensaje': 'No se pudo obtener lista de ubicaciones.'
    },
    {
        'codigo': 'ErrorGetLocation2',
        'mensaje': 'No se pudo obtener lista de ubicaciones.'
    },
    {
        'codigo': 'ErrorGetLocation3',
        'mensaje': 'No se pudo obtener lista de ubicaciones.'
    },
    {
        'codigo': 'ErrorGetLocation4',
        'mensaje': 'No se pudo obtener lista de ubicaciones.'
    },
    {
        'codigo': 'ErrorGetPagination',
        'mensaje': TxtProblemasEjecutar + 'al realizar la paginación de datos.'
    },
    {
        'codigo': 'ErrorGetPoliticaContrasena',
        'mensaje': TxtProblemasObtener + 'las políticas de contraseñas.'
    },
    {
        'codigo': 'ErrorGetRecoveryPassInfo',
        'mensaje': TxtProblemasEjecutar + 'al realizar el proceso de recuperación de contraseña.'
    },
    {
        'codigo': 'ErrorGetUserImage',
        'mensaje': 'No se pudo obtener la imagen del usuario.'
    },
    {
        'codigo': 'ErrorHistoricoContrasena',
        'mensaje': TxtProblemasEjecutar + 'al realizar el proceso de recuperación de contraseña.'
    },
    {
        'codigo': 'ErrorIdiomaNotEmty',
        'mensaje': TxtProblemasEjecutar + 'al validar el idioma, intentelo nuevamente.'
    },
    {
        'codigo': 'ErrorListAcaProgram',
        'mensaje': TxtProblemasObtener + 'los programas académicos.'
    },
    {
        'codigo': 'ErrorListAdmissions',
        'mensaje': TxtProblemasObtener + 'las admisiones del estudiante.'
    },
    {
        'codigo': 'ErrorListCampus',
        'mensaje': TxtProblemasObtener + 'la lista de sedes.'
    },
    {
        'codigo': 'ErrorListCareer',
        'mensaje': TxtProblemasObtener + 'la lista de carreras.'
    },
    {
        'codigo': 'ErrorListCourse',
        'mensaje': TxtProblemasObtener + 'la lista de cursos.'
    },
    {
        'codigo': 'ErrorListCursosProgramas',
        'mensaje': TxtProblemasObtener + 'la lista de cursos del programa.'
    },
    {
        'codigo': 'ErrorListPeriodosAca',
        'mensaje': TxtProblemasObtener + 'la lista de periodos académicos.'
    },
    {
        'codigo': 'ErrorListRequiredFieldsSec',
        'mensaje': TxtProblemasObtener + 'la lista de campos requeridos.'
    },
    {
        'codigo': 'ErrorListSystemCode',
        'mensaje': TxtProblemasObtener + 'la lista de registros por códigos de sistema.'
    },
    {
        'codigo': 'ErrorLocationId1NotNull',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorLocationId2NotNull',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorLocationId3NotNull',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorLocationId4NotNull',
        'mensaje': 'Debe seleccionar la ubicación.'
    },
    {
        'codigo': 'ErrorLowercaseLetter',
        'mensaje': 'Debe ingresar al menos una letra minúscula.'
    },
    {
        'codigo': 'ErrorMaximumCharacters',
        'mensaje': 'Sobrepasa el máximo de caracteres permitidos.'
    },
    {
        'codigo': 'ErrorMinimumCharacters',
        'mensaje': 'No cumple con el mínimo de caracteres permitidos.'
    },
    {
        'codigo': 'ErrorModuleNotEmty',
        'mensaje': TxtProblemasObtener + 'los datos del módulo activo.'
    },    
    {
        'codigo': 'ErrorNoExisteUsuario',
        'mensaje': 'El usuario no existe.'
    },    
    {
        'codigo': 'ErrorNumber',
        'mensaje': 'Debe ingresar al menos un número.'
    },
    {
        'codigo': 'ErrorOptionIdNotEmty',
        'mensaje': TxtProblemasObtener + 'los datos de la opción.'
    },
    {
        'codigo': 'ErrorProcessingAction',
        'mensaje': TxtProblemasEjecutar + 'al realizar la acción, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorProfileNotEmty',
        'mensaje': 'No se logró identificar el tipo de CIF.'
    },
    {
        'codigo': 'ErrorDscLongitud100',
        'mensaje': 'La descripción no debe sobrepasar los 100 caracteres.'
    },
    {
        'codigo': 'ErrorDscLongitud200',
        'mensaje': 'La descripción no debe sobrepasar los 200 caracteres.'
    },
    {
        'codigo': 'ErrorReadDynamicFields',
        'mensaje': TxtProblemasObtener + 'la información de campos dinámicos.'
    },
    {
        'codigo': 'ErrorRecoveryPassToken',
        'mensaje': TxtProblemasEjecutar + 'al validar el enlace de recuperación contraseña.'
    },
    {
        'codigo': 'ErrorSaveCustomerImage',
        'mensaje': TxtProblemasEjecutar + 'al guardar la imagen.'
    },
    {
        'codigo': 'ErrorSaveDinamycFields',
        'mensaje': TxtProblemasEjecutar + 'al guardar la información ingresada.'
    },
    {
        'codigo': 'ErrorSaveLogoutLog',
        'mensaje': TxtProblemasEjecutar + 'con los registros de auditoría.'
    },
    {
        'codigo': 'ErrorSaveLoginLog',
        'mensaje': TxtProblemasEjecutar + 'con los registros de auditoría.'
    },
    {
        'codigo': 'ErrorSaveUserImage',
        'mensaje': TxtProblemasEjecutar + 'al guardar la imagen.'
    },
    {
        'codigo': 'ErrorSeccionCodeLongitud',
        'mensaje': TxtProblemasEjecutar + 'al validar la sección de los campos requeridos.'
    },
    {
        'codigo': 'ErrorSeccionCodeNotEmty',
        'mensaje': TxtProblemasEjecutar + 'al validar la sección de los campos requeridos.'
    },
    {
        'codigo': 'ErrorSetAccessModule',
        'mensaje': TxtProblemasEjecutar + 'al acceder al módulo.'
    },
    {
        'codigo': 'ErrorSetAccessOption',
        'mensaje': TxtProblemasEjecutar + 'al acceder a la opción.'
    },
    {
        'codigo': 'ErrorSetLanguageUser',
        'mensaje': TxtProblemasEjecutar + 'al cambiar de idioma.'
    },
    {
        'codigo': 'ErrorSpecialCharacter',
        'mensaje': 'Debe ingresar el menos un carácter especial.'
    },
    {
        'codigo': 'ErrorSystemCodeIdNotEmty',
        'mensaje': 'Debe seleccionar el tipo del código de sistema.'
    },
    {
        'codigo': 'ErrorTypesSystemCode',
        'mensaje': TxtProblemasObtener + 'los tipos de códigos de sistema.'
    },
    {
        'codigo': 'ErrorUrlBaseNotEmty',
        'mensaje': 'Problemas con la configuración del Class Limitless, por favor comuníquese con el administrador del sistema.'
    },
    {
        'codigo': 'ErrorUserAutorization',
        'mensaje': TxtProblemasObtener + 'los permisos de usuario.'
    },
    {
        'codigo': 'ErrorUsuarioNotEmty',
        'mensaje': 'No se encontraron los datos del usuario.'
    },
    {
        'codigo': 'ErrorValidatingAccessModule',
        'mensaje': TxtProblemasEjecutar + 'al validar el acceso al módulo.'
    },
    {
        'codigo': 'ErrorValidatingAccessOption',
        'mensaje': TxtProblemasEjecutar + 'al validar el acceso a la opción.'
    },
    {
        'codigo': 'ErrorValidatingUserAction',
        'mensaje': TxtProblemasEjecutar + 'al validar los permisos del usuario.'
    },
    {
        'codigo': 'ErrorVowel',
        'mensaje': 'Debe ingresar al menos una vocal.'
    },
    {
        'codigo': 'FailedToValidate',
        'mensaje': TxtProblemasEjecutar + 'al realizar los procesos de validación.'
    },
    {
        'codigo': 'SystemCodeErrorInsert',
        'mensaje': TxtProblemasEjecutar + 'al ingresar el registro.'
    },    
    {
        'codigo': 'ErrorUserNameNotEmty',
        'mensaje': 'Nombre de usuario vacío.'
    },
    //mensajeria
    {
        'codigo': 'ErrorMessageList',
        'mensaje': 'Se presentaron problemas al obtener el listado de mensajes.'
    },
    {
        'codigo': 'ErrorNewMessage',
        'mensaje': TxtProblemasEjecutar + 'al enviar el mensaje.'
    },
    {
        'codigo': 'ErrorRepplyMessage',
        'mensaje': TxtProblemasEjecutar + 'al enviar el mensaje.'
    },
    {
        'codigo': 'ErrorDeleteMessage',
        'mensaje': TxtProblemasEjecutar + 'al eliminar el mensaje.'
    },
    {
        'codigo': 'ErrorDeleteMulMessage',
        'mensaje': TxtProblemasEjecutar + 'al eliminar los mensajes.'
    },
    {
        'codigo': 'ErrorMessageDetail',
        'mensaje': 'Se presentaron problemas al obtener el detalle del mensaje.'
    },
    {
        'codigo': 'ErrorReadMessage',
        'mensaje': 'Se presentaron problemas al establecer el mensaje como leído.'
    },
    {
        'codigo': 'ErrorUnReadMessage',
        'mensaje': 'Se presentaron problemas al establecer el mensaje como no leído.'
    },
    {
        'codigo': 'ErrorUnReadMulMessage',
        'mensaje': 'Se presentaron problemas al establecer los mensajes como no leídos.'
    },
    {
        'codigo': 'ErrorRecipientMessageList',
        'mensaje': 'Se presentaron problemas al obtener la lista de destinatarios.'
    },
    {
        'codigo': 'ErrorAttachmentsMessageList',
        'mensaje': 'Se presentaron problemas al cargar el archivo adjunto.'
    },
    {
        'codigo': 'ErrorRecipientList',
        'mensaje': 'Se presentaron problemas al obtener la lista de destinatarios.'
    },
    {
        'codigo': 'ErrorReadMulMessage',
        'mensaje': 'Se presentaron problemas al establecer los mensajes como leídos.'
    },
    {
        'codigo': 'ErrorMessageIdNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos del mensaje.'
    },
    {
        'codigo': 'ErrorDestinataryNotNull',
        'mensaje': 'Se presentaron problemas al obtener los datos del destinatario.'
    },
    {
        'codigo': 'ErrorSubjectNotNull',
        'mensaje': 'Debe ingresar el asunto del mensaje.'
    },
    {
        'codigo': 'ErrorFilterDscNotEmpty',
        'mensaje': 'Debe ingresar una descripción.'
    },
    {
        'codigo': 'ErrorRemitentNotNull',
        'mensaje': 'Se presentaron problemas al obtener los datos del remitente.'
    },
    {
        'codigo': 'ErrorMessageListNotEmpty',
        'mensaje': 'Debe seleccionar al menos un mensaje de la lista.'
    },
    {
        'codigo': 'ErrorReceiverTypeNotEmpty',
        'mensaje': 'Se presentaron problemas al obtener los datos del destinatario.'
    },    
    //fin mensajeria
    {
        'codigo': 'ErrorGetBaseCurrency',
        'mensaje': 'Se presentaron problemas al obtener la moneda de la compañía.'
    },
    {
        'codigo': 'ErrorObtenerImagen',
        'mensaje': 'Se presentaron problemas al obtener la imagen.'
    },
    {
        'codigo': 'ErrorCIFTypeNotEmpty',
        'mensaje': 'No se encontró el tipo de CIF.'
    },
    {
        'codigo': 'ErrorImageNameNotEmpty',
        'mensaje': 'No se encontró el nombre de la imagen.'
    },
    {
        'codigo': 'ErrorElementIdNotEmpty',
        'mensaje': 'Se presentaron problemas al identificar el registro.'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'Formato de archivo (extensión) no permitido.'
    },
    {
        'codigo': 'ErrorActivoCampana',
        'mensaje': 'Se presentaron problemas al obtener las campañas de actualización de datos.'
    },
    {
        'codigo': 'ErrorCampanaFinalizado',
        'mensaje': 'Se presentaron problemas al actualizar las campañas de actualización de datos.'
    },
    {
        'codigo': 'ErrorActualizarDatosSeccion',
        'mensaje': 'Se presentaron problemas al obtener las secciones de datos de perfiles.'
    },
    //FIN MENSAJES CORE
]